var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBehance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,10.3c0,0.4-0.1,0.8-0.2,1.1c-0.2,0.3-0.4,0.6-0.7,0.8c-0.3,0.2-0.6,0.4-1,0.5c-0.4,0.1-0.8,0.2-1.2,0.2 H0.3V3.2h5.2c0.3,0,0.6,0.1,0.9,0.2C6.6,3.5,6.9,3.7,7,3.9c0.2,0.2,0.3,0.5,0.4,0.8C7.6,5,7.6,5.3,7.6,5.6c0,0.5-0.1,0.9-0.4,1.3 c-0.2,0.4-0.6,0.7-1,0.9c0.6,0.2,1,0.5,1.3,0.9C7.9,9.2,8.1,9.7,8.1,10.3z M2.1,4.8v2.4h2.5c0.3,0,0.6-0.1,0.8-0.3 C5.7,6.7,5.8,6.4,5.8,6c0-0.4-0.1-0.7-0.3-0.9C5.3,4.9,5,4.8,4.7,4.8H2.1z M6.2,10c0-0.2,0-0.3-0.1-0.5C6,9.3,5.9,9.2,5.8,9.1 C5.7,9,5.6,8.9,5.5,8.8C5.3,8.7,5.2,8.7,5,8.7H2.1v2.5h2.8c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.3-0.4 C6.1,10.3,6.2,10.2,6.2,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,12.8c-0.6,0-1.1-0.1-1.5-0.3c-0.9-0.4-1.5-1-1.9-1.9c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4 C9.1,7,9.7,6.3,10.6,6c0.5-0.2,1-0.3,1.5-0.3c0.6,0,1.1,0.1,1.5,0.3c1.5,0.6,2.1,2.1,2.1,3.6c0,0.1,0,0.2,0,0.3h-5.3 c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.3,0.6,0.3c0.2,0.1,0.4,0.1,0.7,0.1c0.4,0,0.7-0.1,1-0.3 c0.3-0.2,0.5-0.4,0.6-0.7l1.5,0.4c-0.3,0.5-0.7,1-1.2,1.3C13.6,12.7,12.9,12.8,12.1,12.8z M13.9,8.7c0-0.5-0.2-0.9-0.6-1.2 c-0.3-0.3-0.8-0.5-1.2-0.5c-0.2,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.5,0.3c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.2-0.2,0.4-0.2,0.7 L13.9,8.7L13.9,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,3.6h4.6v1.1H9.8V3.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBehance);
export default __webpack_public_path__ + "static/media/icon-behance.424167ffc239b82862a2a77d4caf350d.svg";
export { ForwardRef as ReactComponent };